import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-pink-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Điều khoản sử dụng</h1>
        <p className="text-gray-600 mb-8">Cập nhật lần cuối: Tháng 3 năm 2026</p>

        <div className="prose prose-pink max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Chấp nhận điều khoản</h2>
            <p className="text-gray-600">
              Bằng cách sử dụng ứng dụng An Nhi ("Dịch vụ"), bạn đồng ý bị ràng buộc bởi các điều khoản sử dụng này.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Mô tả dịch vụ</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Trợ lý AI tư vấn sức khỏe thai kỳ</li>
              <li>Theo dõi lịch khám thai</li>
              <li>Lưu trữ hồ sơ y tế</li>
              <li>Cộng đồng chia sẻ kinh nghiệm</li>
              <li>Thông báo nhắc nhở qua Facebook Messenger</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Tuyên bố miễn trừ trách nhiệm y khoa</h2>
            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg">
              <p className="text-gray-700 font-medium mb-2">QUAN TRỌNG</p>
              <p className="text-gray-600">
                An Nhi KHÔNG phải là dịch vụ y tế chuyên nghiệp. Thông tin từ ứng dụng chỉ mang tính tham khảo.
                Luôn tham khảo bác sĩ hoặc chuyên gia y tế trước khi đưa ra quyết định về sức khỏe.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Liên hệ</h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-gray-800"><strong>An Nhi</strong></p>
              <p className="text-gray-600">Email: caoanh0928@gmail.com</p>
              <p className="text-gray-600">Website: https://annhi.site</p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfService;